module.exports = __webpack_public_path__ + "static/media/sketch.1c3ae957.svg";